window.app = window.app || {};

(function($) {

	formHelper.addIPeerRule({

		iframe_custom_event_handler: function(payload){
			// this is where we might look at the payload and do differnt
			// things depending on what message we got from the iframe
			// But in 99% of the cases, there is probably only 1 reason
			// for a custom event handler... showing the CVV dialog
			// so ignore the payload
			var event = payload.event;
			switch (event) {
				case "whatisthis":
					toggleCIDHelper();
					break;
				case "cardtypechange":
					// set hidden to payload value
					$('#card-type-amex').val(payload.usingAMEX);
					break;
				case "outstandingchargetotalchange":
					// set hidden to payload value
					$('#outstanding-charge-total').val(payload.outstandingtotal);
					break;
			}
		}
	});

	window.app.doCheckOutstandingChargeTotal = function() {
		if ($('#outstanding-charge-total').length > 0) {
			var outstandingChargeTotal = $('#outstanding-charge-total').val();
			if (parseFloat(outstandingChargeTotal) === 0.00) {
				return true;
			}
			else {
				var p = $('<p>').text(localizedForJS.splitPaymentOutstandingCharge.unescapeHTML())[0];
				toggleBlanket('alert',p,'');
				return false;
			}
		}
		return true;
	}

	window.app.promoCodeFieldEmpty = function() {
		var promoCode = $.trim($("#promoCode").val());
		if (promoCode.length > 0) {
			var para = new Element('p');
			para.update(localizedForJS.pleaseSubmitPromoCode);
			toggleBlanket('alert',para,'');
			return false;
		}
		else {
			 return true;
		}
	}

})(jQuery);

jQuery(function($) {

	$(document).on('change','.js-billing-country',function(event) {

		var billingCountry = $(this).val();

		var cpfContainer = $('.js-cpf-container');
		if (billingCountry === 'Brazil' ) {
			cpfContainer.find('.label').addClass('required');
			cpfContainer.find('.js-cpf').prop('disabled',false);
			cpfContainer.show();
		}
		else {
			cpfContainer.find('.label').removeClass('required');
			cpfContainer.find('.js-cpf').val('').prop('disabled',true);
			cpfContainer.hide();
		}

		var cuitContainer = $('.js-cuit-container');
		if (billingCountry === 'Argentina' ) {
			cuitContainer.find('.label').addClass('required');
			cuitContainer.find('.js-cuit').prop('disabled',false);
			cuitContainer.show();
		}
		else {
			cuitContainer.find('.label').removeClass('required');
			cuitContainer.find('.js-cuit').val('').prop('disabled',true);
			cuitContainer.hide();
		}

		var nitContainer = $('.js-nit-container');
		if (billingCountry === 'Colombia' ) {
			nitContainer.find('.label').addClass('required');
			nitContainer.find('.js-nit').prop('disabled',false);
			nitContainer.show();
		}
		else {
			nitContainer.find('.label').removeClass('required');
			nitContainer.find('.js-nit').val('').prop('disabled',true);
			nitContainer.hide();
		}

		event.preventDefault();
		if (formHelper.portholeSendFHIPeerCustomEvent) {
			formHelper.portholeSendFHIPeerCustomEvent({"event":"bcountrychange","billingcountry":$(this).val()});
		}
	});

});

jQuery(function($){

	$(document).on('change','.js-traveler-country',function(event){
		event.preventDefault();
		if (formHelper.portholeSendFHIPeerCustomEvent) {
			formHelper.portholeSendFHIPeerCustomEvent({"event":"countrychange","travelercountry":$(this).val()});
		}
	});

});

jQuery(function($) {

	$(document.body).on('click', '.js-toggle-password-display', function() {

		var $clickedOnToggle = $(this);
		var toggleType       = $clickedOnToggle.data('password-display');
		var $formField       = $clickedOnToggle.closest('.formfield, .formField');
		var $passwordInput   = $formField.find('.js-toggle-password-input');

		if (toggleType === 'show') {

			$clickedOnToggle.data('password-display','hide');
			$clickedOnToggle.addClass('fa-eye-slash');
			$passwordInput.attr('type','text');
		}
		else {

			$clickedOnToggle.data('password-display','show');
			$clickedOnToggle.removeClass('fa-eye-slash');
			$passwordInput.attr('type','password');
		}

	});
});
